module.exports = __webpack_public_path__ + "static/media/electra-logo-w.dd5afb99.png";